var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 951.427,
    height: 1663.965,
    viewBox: "0 0 951.427 1663.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 336.384,
    cy: 336.383,
    rx: 336.384,
    ry: 336.383,
    transform: "translate(170.353 608.319) rotate(-45)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(-170.353 -132.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M970.194,1184.26h-110c-16.4,0-30.7,12.636-31.189,29.027a29.948,29.948,0,0,0,29.934,30.87h23.848l-97.855,97.854A247.353,247.353,0,0,0,644.3,1299.626c-132.574.924-242.323,107.791-246.571,240.3-4.605,143.62,112.712,261.009,256.307,256.519,132.462-4.141,239.4-113.721,240.5-246.244a247.345,247.345,0,0,0-51.711-153.772l95.351-95.35v20.865a29.948,29.948,0,0,0,29.948,29.948h2.16a29.948,29.948,0,0,0,29.948-29.948V1214.3A30.043,30.043,0,0,0,970.194,1184.26ZM821.413,1559.51c-5.525,87.444-76.479,158.4-163.923,163.926a175.726,175.726,0,0,1-186.75-186.75c5.526-87.444,76.48-158.4,163.924-163.924A175.722,175.722,0,0,1,821.413,1559.51Z",
    fill: "#008dc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M646.074,188.361c-231.562,0-419.955,188.393-419.955,419.957s188.393,419.955,419.955,419.955,419.96-188.391,419.96-419.955S877.641,188.361,646.074,188.361Zm0,756.34c-185.482,0-336.382-150.9-336.382-336.382s150.9-336.384,336.382-336.384,336.387,150.9,336.387,336.384S831.56,944.7,646.074,944.7Z",
    fill: "#008dc9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 336.382,
    cy: 336.384,
    rx: 336.382,
    ry: 336.384,
    transform: "translate(170.354 608.317) rotate(-45)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M485.239,589.491l6.715,51.834c1.3,10.061,11.53,18.027,23.577,18.368h0l-12.538-72.574-5.823-3.325C491.645,580.639,484.533,584.035,485.239,589.491Z",
    fill: "#f0b976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M795.448,581.474l-5.824,3.326-12.538,72.574c12.048-.341,22.274-8.307,23.578-18.368l6.715-51.835C808.085,581.715,800.973,578.32,795.448,581.474Z",
    fill: "#f0b976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M593.89,810.086c69.466,132.037,99.379,17.85,114.39,0V762.211H593.89Z",
    fill: "#dba465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M790.2,544.9c-10.716-99.411-57.541-164.6-143.79-164.6s-133.075,65.2-143.791,164.6c-.92,8.53-.549,35.2-.573,44.03-.064,22.423,8.262,61.152,12.6,78.182,2.623,10.291,53.721,117.753,131.76,117.753S775.545,677.405,778.168,667.114c4.342-17.03,12.669-55.759,12.6-78.182C790.749,580.1,791.12,553.432,790.2,544.9Z",
    fill: "#f0b976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M530.348,535.669c-.817-57.547,46.3-67.5,64.39-69.2,6.135-.576,12.254-1.263,18.369-2.022,32.464-4.031,124.4-10.047,146.936,46.969,0,0,14.3,66.149,26.547,94.378h.642c.871-2.235,1.746-4.626,2.617-7.224,5.64-16.81-.794-46.408,2.09-82.143,4.089-50.693-32.376-87.242-62.27-106.628a26.277,26.277,0,0,0-1.144-5.4,53.972,53.972,0,0,0-6.836-13.819,54.993,54.993,0,0,0-29.376-21.09c-118.382-36.564-161.919,16.151-171.053,31.681-9.377,15.943-.626,19.264-8.127,24.578s-10,17.272-8.127,26.2,12.711,18.749,3.146,25.392-9.4,23.474-9.4,23.474c-5.252,36.827.475,73.647,6.532,98.926q.756,3.156,1.512,6.051l-.052-.031.022.036h2.785C518.561,592.509,531.006,582.056,530.348,535.669Z",
    fill: "#291d15"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M743.756,789.723H708.28s-52.874,48.676-114.39,0H545.569q-2.412,0-4.809.055C448.881,791.9,376.1,868.338,376.1,960.241v68.032H926.074v-66.14c0-74.991-48.775-141.87-120.7-163.113A222.609,222.609,0,0,0,743.756,789.723Z",
    fill: "#085269"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.9c1c48236dcac0bda26ad70515e32317.svg";
export { ForwardRef as ReactComponent };